import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'evenements',
    loadComponent: () => import('./pages/evenements/evenements.page').then(m => m.EvenementsPage)
  },
  {
    path: 'evenements/:id',
    loadComponent: () => import('./pages/evenements/evenement/evenement.page').then(m => m.EvenementPage)
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage)
  },
  {
    path: 'profile-form',
    loadComponent: () => import('./pages/profile/profile-form/profile-form.page').then(m => m.ProfileFormPage)
  },
  {
    path: 'notifications',
    loadComponent: () => import('./pages/notifications/notifications.page').then(m => m.NotificationsPage)
  },
  {
    path: 'planning',
    loadComponent: () => import('./pages/planning/planning.page').then(m => m.PlanningPage)
  },
  {
    path: 'planning/:date',
    loadComponent: () => import('./pages/planning/planning-date/planning-date.page').then(m => m.PlanningDatePage)
  },
  {
    path: 'invitations',
    loadComponent: () => import('./pages/invitations/invitations.page').then(m => m.InvitationsPage)
  },
  {
    path: 'organismes',
    loadComponent: () => import('./pages/organismes/organismes.page').then(m => m.OrganismesPage)
  },
  {
    path: 'organismes/creation',
    loadComponent: () => import('./pages/organismes/organisme-form/organisme-form.page').then(m => m.OrganismeFormPage)
  },
  {
    path: 'organismes/:idOrganisme',
    loadComponent: () => import('./pages/organismes/organisme/organisme.page').then(m => m.OrganismePage)
  },
  {
    path: 'organismes/:idOrganisme/modification',
    loadComponent: () => import('./pages/organismes/organisme-form/organisme-form.page').then(m => m.OrganismeFormPage)
  },
  {
    path: 'groupes',
    loadComponent: () => import('./pages/groupes/groupes.page').then(m => m.GroupesPage)
  },
  {
    path: 'groupes/creation',
    loadComponent: () => import('./pages/groupes/groupe-form/groupe-form.page').then(m => m.GroupeFormPage)
  },
  {
    path: 'groupes/:idGroupe',
    loadComponent: () => import('./pages/groupes/groupe/groupe.page').then(m => m.GroupePage)
  },
  {
    path: 'groupes/:idGroupe/modification',
    loadComponent: () => import('./pages/groupes/groupe-form/groupe-form.page').then(m => m.GroupeFormPage)
  },
  {
    path: 'comptes-partages',
    loadComponent: () => import('./pages/comptes-partages/comptes-partages.page').then(m => m.ComptesPartagesPage)
  },
  {
    path: 'partitions',
    loadComponent: () => import('./pages/partitions-groupes/partitions-groupes.page').then( m => m.PartitionsGroupesPage)
  },
  {
    path: 'partitions/:idUserGroupe',
    loadComponent: () => import('./pages/partitions-morceaux/partitions-morceaux.page').then( m => m.PartitionsMorceauxPage)
  },
  {
    path: 'partitions/:idUserGroupe/:idMorceau',
    loadComponent: () => import('./pages/partitions-groupe-instruments/partitions-groupe-instruments.page').then( m => m.PartitionsGroupeInstrumentsPage)
  },
  {
    path: 'partitions/:idUserGroupe/:idMorceau/:idInstrument',
    loadComponent: () => import('./pages/partitions-liste/partitions-liste.page').then( m => m.PartitionsListePage)
  },
  {
    path: 'login-google-callback',
    loadComponent: () => import('./pages/login-google-callback/login-google-callback.page').then( m => m.LoginGoogleCallbackPage)
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
